import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useRecipientsSelectContext } from './RecipientsSelectContext'

/**
 * a complex {@link CIMSSelect} component for users, non user emails,
 * and recipient groups (if included in provider)
 *
 * wrap anything using this component in the RecipientsSelectProvider
 *
 * @deprecated Use the `customWorkflows/RecipientSelect` component if working
 * with custom workflows.
 */
const RecipientsSelect: React.FC<CommonSelect<'virtual' | 'mode'>> = (
  props
) => {
  const { options, loading } = useRecipientsSelectContext()
  return (
    <CIMSSelect
      options={options}
      mode="multiple"
      loading={loading}
      virtual
      {...props}
    />
  )
}

export default RecipientsSelect
